import {
  MolsonBox,
  MolsonButton,
  MolsonIcon,
  MolsonTypography
} from '@components/reusable'
import { IconButton, useMediaQuery } from '@mui/material'
import { molsonUseTheme } from '@theme/customMuiExports'
import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

type PwaInstallPromptUtilsType = {
  setShowIosInstructions: Dispatch<SetStateAction<boolean>>
  handleDismiss: () => void
}

export const usePwaInstallPromptUtils = ({
  setShowIosInstructions,
  handleDismiss
}: PwaInstallPromptUtilsType) => {
  const theme = molsonUseTheme()
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')
  const { t } = useTranslation('', { keyPrefix: 'common.pwa' })

  const showPromptForIos = () => {
    return (
      <MolsonBox
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          p: 2,
          bgcolor: prefersDarkMode
            ? theme.palette.secondary[700]
            : theme.palette.secondary[100],
          boxShadow: `0 -4px 12px ${theme.palette.primary.lightShadow}`
        }}
      >
        <MolsonBox sx={{ maxWidth: 600, mx: 'auto' }}>
          <MolsonBox
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 1
            }}
          >
            <MolsonTypography
              sx={{
                fontWeight: 'bold',
                fontSize: 17,
                lineHeight: 1.2,
                color: prefersDarkMode
                  ? theme.palette.secondary[50]
                  : theme.palette.secondary[900]
              }}
            >
              {t('installApp')}
            </MolsonTypography>
            <IconButton
              onClick={() => setShowIosInstructions(false)}
              size="small"
              sx={{
                color: prefersDarkMode
                  ? theme.palette.secondary[50]
                  : theme.palette.secondary[500]
              }}
            >
              <MolsonIcon variant="CLOSE_X" />
            </IconButton>
          </MolsonBox>

          <MolsonBox sx={{ mb: 1.5 }}>
            <MolsonTypography
              sx={{
                fontSize: 13,
                lineHeight: 1.2,
                mb: 1,
                color: prefersDarkMode
                  ? theme.palette.secondary[400]
                  : theme.palette.secondary[500]
              }}
            >
              {t('iosInstructions')}
            </MolsonTypography>
            <ol
              style={{
                margin: 0,
                paddingLeft: 20,
                fontSize: 13,
                lineHeight: 1.3,
                color: prefersDarkMode
                  ? theme.palette.secondary[400]
                  : theme.palette.secondary[500]
              }}
            >
              <li style={{ marginBottom: 6 }}>
                <MolsonIcon variant="SHARE" /> {t('iosStep1')}
              </li>
              <li style={{ marginBottom: 6 }}>{t('iosStep2')}</li>
              <li>{t('iosStep3')}</li>
            </ol>
          </MolsonBox>

          <MolsonButton
            fullWidth={true}
            variant="contained"
            onClick={handleDismiss}
            sx={{ borderRadius: '40px', fontSize: 15, p: 0, paddingInline: 1 }}
          >
            {t('gotItButton')}
          </MolsonButton>
        </MolsonBox>
      </MolsonBox>
    )
  }

  return {
    showPromptForIos
  }
}
